import React, { useEffect, useState} from 'react';
import Slider from 'react-slick';
import CustomNextArrow from "../../library/baaShared/CustomArrow/CustomNextArrow";
import nextImage from "../../assets/icons-icon-arrow-left@2x.png";
import ComponentTitleSection from '../../library/baaShared/ComponentTitleSection';
import "./Gallery.scss";
import Insta from "../../assets/instagramNew.webp";
const Gallery = (props) => {
 
 
  const[matches,setMatches] = useState(window.matchMedia("(min-width: 768px)").matches)
  const [current, setCurrent] = useState(0);
  const [isNext, setIsNext] = useState(false);
  const [length, setLength] = useState(props.fields.Image.length);
  const [previous, setPrevious] = useState(0);
  const [slideIndex, setSlideIndex] = useState(0);
  const nextClick = () => {
    if (current < length) {
      setCurrent(current + 1);
    }
    if (current >= length) {
      setCurrent(0);
    }
  };

  useEffect(()=>{
    const handler = e => setMatches(matches)
    window.matchMedia("(min-width: 768px)").addListener(handler);
 })

  const previousClick = () => {
    if (current > 0) {
      setCurrent(current - 1);
    }
    if (current <= 0) {
      setCurrent(current - 1 + (length + 1));
    }
  };

  const setting = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "250px",
    slidesToShow: 1,
    speed: 500,
    arrows: true,
    nextArrow: <CustomNextArrow img={nextImage} onClick={nextClick} />,
    prevArrow: <CustomNextArrow img={nextImage} onClick={previousClick} />,
    beforeChange: (current, next) => {
      setPrevious(current);

      setSlideIndex(next);
    },

    responsive: [
      {
        breakpoint: 600,
        settings: {
          infinite: true,
          arrows: false,
          centerPadding: "20px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          centerPadding: "100px",
        },
      },
      // {
      //   breakpoint: 1024,
      //   settings: {
      //     centerPadding: "110px",
      //   }
      // }
    ],
  };
  const homePageSettings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "250px",
    slidesToShow: 3,
    speed: 500,
    arrows: true,
    nextArrow: <CustomNextArrow img={nextImage} onClick={nextClick} />,
    prevArrow: <CustomNextArrow img={nextImage} onClick={previousClick} />,
    beforeChange: (current, next) => {
      setPrevious(current);

      setSlideIndex(next);
    },

    responsive: [
      {
        breakpoint: 600,
        settings: {
          infinite: true,
          arrows: false,
          centerPadding: "20px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 900,
        settings: {
          centerPadding: "100px",
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          centerPadding: "110px",
          slidesToShow: 2,
        }
      }
    ],
  };
  let path = window.location.pathname;
  var settings;
  if (path === "/en/experience-collection") {
    settings = { paddingBottom: "130px" }
  }
  return (
    <div className="gallery-wrapper">
      {/* <ComponentTitleSection
        title={props.fields["Title"] && props.fields["Title"].value}
        subtitle={props.fields["Tagline"] && props.fields["Tagline"].value}
      /> */}
      {}
     <div className="section-title-container">
       {matches===true ?
      <h2>
        {props.fields["Tagline"] && props.fields["Tagline"].value}<br/>
        <small>{props.fields["Title"] && props.fields["Title"].value}</small>         
      </h2>:  <h2 >
            
            {props.fields["Mobile Tagline"] && props.fields["Mobile Tagline"].value != "" ?
              <h2 dangerouslySetInnerHTML={{
              __html:
               props.fields["Mobile Tagline"] && props.fields["Mobile Tagline"].value
            }}></h2>
            : props.fields["Tagline"] && props.fields["Tagline"].value}<br/><small>{props.fields["Title"] && props.fields["Title"].value}</small>
     </h2>}
     
    </div>
      <div className="carousal-wrap">
        {window.location.pathname.includes("experience-collection") &&
        <Slider {...setting}>
          {props.fields.Image && props.fields.Image.length > 0 && props.fields.Image.map((item) => (
            <>
              <div className="gallery-swipe-dom1"></div>
              <div className="gallery-swipe-dom2"></div>
              <div className="gallery-swipe-dom3"></div>
              <div className="gallery-card-wrapper">
                <div className="gallery-img">
                  <div
                    className="video-background"
                    style={{ backgroundImage: `url(${item.fields.Image && item.fields.Image.value && item.fields.Image.value.src})` }}
                  >
                    <div className="video-foreground">
                      <iframe title={"Instagram Social captures"} src="" allowFullScreen frameBorder="0"></iframe>
                    </div>
                  </div>
                </div>
                <div className="gallery-description">
                  {item.fields["Short Description"] && item.fields["Short Description"].value}
                </div>
              </div>
            </>
          ))}
        </Slider>}
        {!window.location.pathname.includes("experience-collection") &&
        <Slider {...homePageSettings}>
          {props.fields.Image && props.fields.Image.length > 0 && props.fields.Image.map((item) => (
            <>
              <div className="gallery-swipe-dom1"></div>
              <div className="gallery-swipe-dom2"></div>
              <div className="gallery-swipe-dom3"></div>
              <div className="gallery-card-wrapper">
                <div className="gallery-img">
                  <div
                    className="video-background"
                    style={{ backgroundImage: `url(${item.fields.Image && item.fields.Image.value && item.fields.Image.value.src})` }}
                  >
                    <img alt="instagramlogo" src={Insta} className={(item.fields["Show Instagram"].value) === true ? "instaLogo" : "instaLogo d-none"} />
                    <div className="video-foreground">
                      <iframe title={"Instagram Social captures"} src="" allowFullScreen frameBorder="0"></iframe>
                    </div>
                  </div>
                </div>
                <div className="gallery-description">
                  {item.fields["Short Description"] && item.fields["Short Description"].value}
                </div>
              </div>
            </>
          ))}
        </Slider>}
      </div>
      {/* <div className="gallery-background" style={{ backgroundImage: `url(${props.fields["Background Image"] && props.fields["Background Image"].value.src})` }}></div> */}
      <div className="vertical-gradient"></div>
    </div>
  );
};

export default Gallery;
